import { useEffect } from 'react';
import { CheckCircle, XCircle, AlertTriangle, Info, X } from 'lucide-react';
import { useToast, type Toast as ToastType } from '../../contexts/ToastContext';
import './Toast.css';

const ICONS = {
    success: CheckCircle,
    error: XCircle,
    warning: AlertTriangle,
    info: Info
};

interface ToastProps {
    toast: ToastType;
}

export default function Toast({ toast }: ToastProps) {
    const { removeToast } = useToast();
    const Icon = ICONS[toast.type];

    useEffect(() => {
        // Trigger enter animation
        const timer = setTimeout(() => {
            const element = document.getElementById(toast.id);
            if (element) {
                element.classList.add('toast--visible');
            }
        }, 10);

        return () => clearTimeout(timer);
    }, [toast.id]);

    const handleClose = () => {
        const element = document.getElementById(toast.id);
        if (element) {
            element.classList.add('toast--exit');
            setTimeout(() => {
                removeToast(toast.id);
            }, 300);
        }
    };

    return (
        <div
            id={toast.id}
            className={`toast toast--${toast.type}`}
            role="alert"
            aria-live="polite"
        >
            <div className="toast__icon">
                <Icon size={20} />
            </div>
            <div className="toast__content">
                <p className="toast__message">{toast.message}</p>
            </div>
            <button
                className="toast__close"
                onClick={handleClose}
                aria-label="Cerrar notificación"
            >
                <X size={16} />
            </button>
        </div>
    );
}
